'use client'

import { create } from 'zustand'

import { createCartActions } from './cart.actions'
import { initialState } from './cart.state'
import { CartState } from './cart.types'

const useCartStore = create<CartState>()((...a) => ({
  ...initialState,
  ...createCartActions(...a)
}))

export const useDisplayCart = () =>
  useCartStore(state => state.optimisticCart || state.cart)

export const useCart = () => useCartStore(state => state.cart)
export default useCartStore 